module.exports = __webpack_public_path__ + "media/application/images/ask-bg@2x-1092167933a6cd315c45ab510bc2efbd9dbaa49cda0bf2b831e3a5fe338ee466.png";